import axios from "axios";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { actions } from "../model";
import { useDispatch, useSelector } from "react-redux";
import { CircularProgress } from "@mui/material";

function TokenRedirect() {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const reduxObject = useSelector((state) => state.user?.redux_object);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const token = params.get("token");
    const email = params.get("email");

    if (token && email) {
      localStorage.setItem("token", token);
      localStorage.setItem("email", email);

      dispatch(actions.loginLexiaTools(token, email));
    }
  }, [location, dispatch]);

  useEffect(() => {
    if (reduxObject?.accessToken) {
      navigate("/");
    }
  }, [reduxObject]);

  return (
    <div
      style={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
      }}
    >
      <CircularProgress style={{ color: "#1b2838" }} />
    </div>
  );
}

export default TokenRedirect;
